<template>
  <div class="">

  </div>
</template>

<script>
import Axios from 'axios'
import _ from 'lodash'
import { mapGetters } from 'vuex'

export default {
  name: "cards-mixins",
  components: {
  },
  data() {
    return {
      reasonForDeclineORM: '',
      locationForDecline: '',
      cardIdForCopy: null,
      ormDeclineCardId: null,
      cardNumberForCopy: null,
      copyCard: {
        isNew: false,
        copyToCardId: '',
        isCopyImages: false,
        isCopyFiles: false,
        copyToCard: {},
        isDelete: false,
        isCopyEstimateValuesOnly: false,
        activeMultiselect: false,
      },
      modal: {},
      searchFilter: '',
      isAutoSave: false,
      card_drag_id: null,
      updateData: {},
      openedNewTabCardId: null,
      debouncedOnSearchFilterChange: null,
    }
  },
  methods: {
    openCardInNewTab(cardId) {
      this.closeTableContext()
      this.openedNewTabCardId = cardId;
      this.openNewTabCard();
    },
    openCardInNewWindow(cardId) {
      this.closeTableContext()
      this.openedNewTabCardId = cardId;
      this.openNewBrowserCard();
    },
    openNewBrowserCard() {
      window.open(
          window.location.origin + "/files/view/" + this.openedNewTabCardId,
          "_blank",
          "toolbar=yes,scrollbars=yes,resizable=yes,top=0,left=0,width=" +
          screen.width +
          ",height=" +
          screen.height
      );
    },
    openNewTabCard() {
      //  console.log(this.openedNewTabCardId);
      window.open(
          window.location.origin + "/files/view/" + this.openedNewTabCardId,
          "_blank"
      );
    },
    beforeDebouncedAutoSave: function () {
      if (!this.isAutoSave) {
        //    console.log('not isAutoSave in beforeDebouncedAutoSave')
        return;
      }
      this.debouncedAutoSave();
    },
    autoSave() {
      if (!this.isAutoSave) {
        //  console.log('not isAutoSave')
        return;
      }
      let card_id = this.$route.params.card_id || this.card_drag_id;
      Axios({
        method: "post",
        responseType: "json",
        headers: {Autosave: true},
        url: `/fe/card/${card_id}`,
        validateStatus: function (status) {
          return status < 500;
        },
        data: this.updateData,
      })
          .then((response) => {
            if (response.status === 200) {
            } else {
            }
            this.isAutoSave = true;
          })
          .catch((error) => {
            this.isAutoSave = true;
          });
    },
    setUpdateData: function (v) {
      //let uid = Math.random().toString(36).substr(2, 9) + Date.now();
      this.updateData = {};
      this.updateData.uid = v;
      this.beforeDebouncedAutoSave();
    },
    setCardPriority(cardId, priority) {
      this.closeTableContext();
      const index = this.cardsAll.findIndex(card => {
        return Number(card.card_id) === Number(cardId);
      });
      if (index !== -1) {
        const card = this.cardsAll[index];
        card.priority = priority;

        let update = {};
        update.priority = priority;
        this.isAutoSave = true;
        this.card_drag_id = cardId;
        this.setUpdateData(update);
      }else{
        console.log('Not Found FILE in setPriority')
      }
    },
    onSearchFilterChange_Old(filters) {
      console.log(filters, 'filters')
      this.$store.commit('card/setSearchFilterObj', filters)
      if (filters && filters[0] && filters[0].search) {
        this.$store.commit('setCardFilter', filters[0].search);
        // this.filter = filters.search;
      } else {
        this.$store.commit('setCardFilter', '');
        // this.filter = '';
      }
    },
    filterCards_Old(value) {
      return _.filter(value, (itm) => {
        if (!this.isCardNumberFilterActive && !this.isPartNumberFilterActive && !this.isInsurerNameFilterActive
            && !this.isRegoFilterActive && !this.isMakeFilterActive && !this.isModelFilterActive && !this.isEstimateNumberFilterActive && !this.isCustomerNameFilterActive) {
          return true
        }
        if (this.isCardNumberFilterActive) {
          if (_.includes((this.computedCardNumberFilter), _.trim(itm.card_number))) {
            return true
          }
        }

        if (this.isInsurerNameFilterActive && _.trim(itm.insurance)) {
          if (_.includes((this.computedInsurerNameFilter), _.trim(itm.insurance))) {
            return true
          }
        }

        if (this.isRegoFilterActive && _.trim(itm.rego_number)) {
          if (_.includes((this.computedRegoFilter), _.trim(itm.rego_number))) {
            return true
          }
        }

        if (this.isMakeFilterActive && _.trim(itm.make)) {
          if (_.includes((this.computedMakeFilter), _.trim(itm.make))) {
            return true
          }
        }
        if (this.isModelFilterActive && _.trim(itm.model)) {
          if (_.includes((this.computedModelFilter), _.trim(itm.model))) {
            return true
          }
        }
        if (this.isPartNumberFilterActive && itm.partNumbers) {
          let isCheckedPartNumber = _.some(itm.partNumbers.split(' '), (n) => {
            return n && _.includes(this.computedPartNumberFilter, n)
          })
          if (isCheckedPartNumber) {
            return true
          }
        }

        if (this.isEstimateNumberFilterActive && _.trim(itm.estimateNumber)) {
          if (_.includes((this.computedEstimateNumberFilter), _.trim(itm.estimateNumber))) {
            return true
          }
        }

        if (this.isCustomerNameFilterActive && _.trim(itm.customer_name)) {
          if (_.includes((this.computedCustomerNameFilter), _.trim(itm.customer_name))) {
            return true
          }
        }
        return false
      })
    },
    getIsActiveFilter(field) {
      for (let key in this.getterSearchFilterObj) {
        if (this.getterSearchFilterObj[key][field]) {
          return true
        }
      }
      return false
    },
    getActiveFilter(field) {
      let filter = {            }
      filter[field] = ''
      let obj = Object.assign({}, this.getterSearchFilterObj)
      for (let key in obj) {
        if (obj[key][field]) {
          filter = obj[key]
          break
        }
      }
      filter = _.split(filter[field], ';')
      return _.filter(filter, (f) => {return _.trim(f)})
    },
    assignedToPerson(data, user) {
      if (data && data.item && data.item.card_id > 0) {
        let card_id = data.item.card_id;
        let uid = Math.random().toString(36).substr(2, 9) + Date.now();
        let update = {};
        update[uid] = {};
        update[uid].assignedTo = {};
        update[uid].assignedTo.id = user;
        Axios({
          method: "post",
          responseType: "json",
          headers: {Autosave: true},
          url: `/fe/card/${card_id}`,
          validateStatus: function (status) {
            return status < 500;
          },
          data: update,
        })
            .then((response) => {
              if (response.status === 200) {
              }
            })
            .catch((error) => {
            });
      }
      this.$refs.rightClickMenuForCards.close();
    },
    completeMarkAs: function () {
      this.$refs.markAsModal.hide();
      let update = {};
      update.state = this.modal.type;
      this.setUpdateData(update);
      var card_id = this.modal.card_id;
      Axios({
        method: "post",
        responseType: "json",
        headers: {Autosave: true},
        url: `/fe/card/${card_id}`,
        validateStatus: function (status) {
          return status < 500;
        },
        data: this.updateData,
      }).then((response) => {
        if (response.status === 200) {
        }
      });
    },
    onRightClickByMenu(type, data) {
      this.closeTableContext();
      if (!this.isStatusActive) {
        return
      }
      var card_id = data.item.card_id;
      Axios.get(`/fe/card/${card_id}`).then((response) => {
        var card = response.data.card;
        if (card && card.estimate_number != "") {
          if (type == 1) {
            this.modal = {
              type: type,
              card_id: card_id,
              title: "File - Mark As Active",
              text:
                  "We have found the following Estimates linked to this file. These will be marked as Active.",
              estimate_number: card.estimate_number,
              supplement_numbers: card.supplement_numbers,
            };
          } else if (type == 0) {
            this.modal = {
              type: type,
              card_id: card_id,
              title: "File - Mark As Open",
              text:
                  "We have found the following Estimates linked to this file. These will be marked as Open.",
              estimate_number: card.estimate_number,
              supplement_numbers: card.supplement_numbers,
            };
          } else if (type == 3) {
            this.modal = {
              type: type,
              card_id: card_id,
              title: "File - Mark As Closed",
              text:
                  "We have found the following Estimates linked to this file. These will be marked as Closed.",
              estimate_number: card.estimate_number,
              supplement_numbers: card.supplement_numbers,
            };
          }
          this.$refs.markAsModal.show();
        } else {
          this.modal = {
            type: type,
            card_id: card_id,
          };
          this.completeMarkAs();
        }
      });
    },
    closeTableContext() {
      this.$nextTick(()=>{
        //   console.log('nextTick.closeTableContext')
        if (this.$refs.rightClickMenuForCards) {
          //   console.log('closeTableContext2 close')
          this.$refs.rightClickMenuForCards.close();
        }
      })
    },
    addToDepartureBoard(id, number) {
      this.closeTableContext();
      NProgress.start();
      Axios({
        method: 'post',
        responseType: 'json',
        url: `/fe/board/departure/add-card`,
        validateStatus: function (status) {
          return status < 500;
        },
        data: {
          cardId: id,
        },
      }).then(response => {
        if (response.status === 200 && response.data._status) {
          toastr.success('File ' + number + ' added successfully to the Departure Board');
        } else {
          toastr.error(response.data.msg);
        }
      })
          .catch(error => {
            toastr.error(error);
          })
          .finally(() => {
            NProgress.done();
          });
    },
    addToVehicleInBoard(id, number) {
      this.closeTableContext();
      NProgress.start();
      Axios({
        method: 'post',
        responseType: 'json',
        url: `/fe/board/in/add-card`,
        validateStatus: function (status) {
          return status < 500;
        },
        data: {
          cardId: id,
        },
      }).then(response => {
        if (response.status === 200 && response.data._status) {
          toastr.success('File ' + number + ' added successfully to the Vehicle In Board');
        } else {
          toastr.error(response.data.msg);
        }
      })
          .catch(error => {
            toastr.error(error);
          })
          .finally(() => {
            NProgress.done();
          });
    },
    markAsRead: function (cardId) {
      this.closeTableContext();
      this.$store.dispatch('markAsReadCardNotification', cardId);
      let item = {};
      item = _.find(this.cards, {'card_id': cardId});
      if (item && item.activity) {
        item.activity.Assignment = {};
        item.activity.Email = {};
        if (item.filters) {
          item.filters = '';
        }
      }
      //
      // item = _.find(this.cardsAll, {'card_id': cardId});
      // if (item && item.activity) {
      //   item.activity.Assignment = {};
      //   item.activity.Email = {};
      //   if (item.filters) {
      //     item.filters = '';
      //   }
      // }

      // item = _.find(this.cardsOpen, {'card_id': cardId});
      // if (item && item.activity) {
      //   item.activity.Assignment = {};
      //   item.activity.Email = {};
      //   if (item.filters) {
      //     item.filters = '';
      //   }
      // }
      //
      // item = _.find(this.cardsActive, {'card_id': cardId});
      // if (item && item.activity) {
      //   item.activity.Assignment = {};
      //   item.activity.Email = {};
      //   if (item.filters) {
      //     item.filters = '';
      //   }
      // }
      //
      // item = _.find(this.cardsClosed, {'card_id': cardId});
      // if (item && item.activity) {
      //   item.activity.Assignment = {};
      //   item.activity.Email = {};
      //   if (item.filters) {
      //     item.filters = '';
      //   }
      // }
    },
    copyCardModal: function (cardId, cardNumber) {
      this.closeTableContext();
      if (!this.isStatusActive) {
        return
      }
      this.cardIdForCopy = cardId;
      this.cardNumberForCopy = cardNumber;
      this.copyCard.isNew = false;
      this.copyCard.copyToCardId = 0;
      this.copyCard.copyToCard = {};
      this.copyCard.isCopyImages = false;
      this.copyCard.isCopyFiles = false;
      this.$refs.copyCardModal.show();
    },
    completeCopyCard: function () {
      this.$refs.copyCardModal.hide();
      NProgress.start();
      if (this.copyCard.copyToCard && this.copyCard.copyToCard.card_id && this.copyCard.copyToCard.card_id > 0) {
        this.copyCard.copyToCardId = this.copyCard.copyToCard.card_id;
      }
      delete this.copyCard.copyToCard;
      Axios({
        method: 'post',
        responseType: 'json',
        url: `/fe/card/${this.cardIdForCopy}/copy-card`,
        validateStatus: function (status) {
          return status < 500;
        },
        data: this.copyCard,
      }).then(response => {
        if (response.status === 200 && response.data._status) {
          if (!this.copyCard.isNew) {
            this.$store.dispatch('card/deleteCardById', this.copyCard.copyToCardId);
          }
          toastr.success('Duplicate File ' + response.data.number + ' created successfully');
          this.$router.push({
            name: 'CardsEdit',
            params: {
              card_id: response.data.id,
              filters: this.$route.params.filters ? this.$route.params.filters : this.$route.query.filters,
              trackerFilter: this.$route.params.trackerFilter ? this.$route.params.trackerFilter : this.$route.query.trackerFilter
            }
          });
          return;
        } else {
          toastr.error(response.data.msg);
        }
      })
          .catch(error => {
            toastr.error(error);
          })
          .finally(() => {
            NProgress.done();
          });
    },
    openDeclineModal(v) {
      this.ormDeclineCardId = v
      this.$refs.declineORMJob.show()
    },
    declineORMJob () {
      this.$refs.declineORMJob.hide();
      NProgress.start();
      Axios.post(`/fe/card/${this.ormDeclineCardId}/orm/job-decline`, {})
          .then(response => {
            if (response?.data?._status) {
              toastr.success('ORM job [TestOrmNumber] has been successfully declined.')
            }
          })
          .catch(error => {
            console.log(error);
          })
          .finally(() => {
            NProgress.done();
          })
    },
    acceptORMJob (id) {
      this.closeTableContext();
      NProgress.start();
      Axios.post(`/fe/card/${id}/orm/job-accept`, {})
          .then(response => {
            if (response?.data?._status) {
              toastr.success('ORM job [ORMnumber] has been successfully Accepted.');
            }
          })
          .catch(error => {
            console.log(error);
          })
          .finally(() => {
            NProgress.done();
          })
    },
    handleSearchFilterChange(filters) {
      this.$store.commit('card/setSearchFilterObj', filters)
      if (filters && filters[0] && filters[0].search) {
        this.$store.commit('setCardFilter', filters[0].search);
      } else {
        this.$store.commit('setCardFilter', '');
      }
    },

    // Replace onSearchFilterChange
    onSearchFilterChange(filters) {
      this.debouncedOnSearchFilterChange(filters);
    },

    // New optimized helper
    filterByText(cards, filter) {
      if (!filter) return cards;
      let filtersFromRoute = [];
      if (this.$route.params && !_.isEmpty(this.$route.params.filters)) {
        filtersFromRoute = this.$route.params.filters;
      }
      if (this.$route.query && !_.isEmpty(this.$route.query.filters)) {
        filtersFromRoute = _.isArray(this.$route.query.filters) ? this.$route.query.filters : [this.$route.query.filters];
      }

      if ((filter == this.$route.params.trackerFilter || filter == this.$route.query.trackerFilter) && !_.isEmpty(filtersFromRoute)) {
        const routeCardIds = new Set(filtersFromRoute.map(id => Number(id)));
        return _.filter(cards, (row) => {
          return routeCardIds.has(Number(row.card_id));
        });
      }

      const f = filter.trim().toLowerCase();
      if (!f) return cards;

      return _.filter(cards, (row) => {
        if (row.card_number && row.card_number.toLowerCase().includes(f)) return true;
        if (row.customer_name && row.customer_name.toLowerCase().includes(f)) return true;
        if (row.rego_number && row.rego_number.toLowerCase().includes(f)) return true;
        if (row.make && row.make.toLowerCase().includes(f)) return true;
        if (row.model && row.model.toLowerCase().includes(f)) return true;

        if (this.isCanSearchBySomeFields) {
          if (row.insurance && row.insurance.toLowerCase().includes(f)) return true;
          if (row.estimateNumber && row.estimateNumber.toLowerCase().includes(f)) return true;
        }
        if (row.claim_number && row.claim_number.toLowerCase().includes(f)) return true;
        return false;
      });
    },

    // Replace filterCards with this optimized version
    filterCards(value) {
      // Pre-calculate active filters to avoid getter lookups inside the loop (8000+ times saved)
      const isCardNumber = this.isCardNumberFilterActive;
      const cardNumbers = isCardNumber ? this.computedCardNumberFilter : null;
      const isInsurer = this.isInsurerNameFilterActive;
      const insurers = isInsurer ? this.computedInsurerNameFilter : null;
      const isRego = this.isRegoFilterActive;
      const regos = isRego ? this.computedRegoFilter : null;
      const isMake = this.isMakeFilterActive;
      const makes = isMake ? this.computedMakeFilter : null;
      const isModel = this.isModelFilterActive;
      const models = isModel ? this.computedModelFilter : null;
      const isPartNumber = this.isPartNumberFilterActive;
      const partNumbers = isPartNumber ? this.computedPartNumberFilter : null;
      const isEstimate = this.isEstimateNumberFilterActive;
      const estimateNumbers = isEstimate ? this.computedEstimateNumberFilter : null;
      const isCustomer = this.isCustomerNameFilterActive;
      const customers = isCustomer ? this.computedCustomerNameFilter : null;

      if (!isCardNumber && !isInsurer && !isRego && !isMake && !isModel && !isPartNumber && !isEstimate && !isCustomer) {
        return value;
      }

      return _.filter(value, (itm) => {
        if (isCardNumber && itm.card_number && _.includes(cardNumbers, _.trim(itm.card_number))) return true;
        if (isInsurer && itm.insurance && _.includes(insurers, _.trim(itm.insurance))) return true;
        if (isRego && itm.rego_number && _.includes(regos, _.trim(itm.rego_number))) return true;
        if (isMake && itm.make && _.includes(makes, _.trim(itm.make))) return true;
        if (isModel && itm.model && _.includes(models, _.trim(itm.model))) return true;

        if (isPartNumber && itm.partNumbers) {
          const parts = itm.partNumbers.split(' ');
          for(let i=0; i<parts.length; i++) {
            if(parts[i] && _.includes(partNumbers, parts[i])) return true;
          }
        }

        if (isEstimate && itm.estimateNumber && _.includes(estimateNumbers, _.trim(itm.estimateNumber))) return true;
        if (isCustomer && itm.customer_name && _.includes(customers, _.trim(itm.customer_name))) return true;
        return false
      })
    },
  },
  created() {
    this.debouncedAutoSave = _.debounce(this.autoSave, 1000);
    this.debouncedOnSearchFilterChange = _.debounce(this.handleSearchFilterChange, 300);
  },
  computed: {
    ...mapGetters({
      cardsAll: 'card/getAllCards',
      isStatusActive: 'isStatusActive',
      getterSearchFilterObj: 'card/getSearchFilterObj',
      isShopManagerUser: 'isShopManagerUser',
      isProductionManagerUser: 'isProductionManagerUser',
      isEstimatorUser: 'isEstimatorUser',
      isPDRTechnicianUser: 'isPDRTechnicianUser',
      isDisplayBoardUser: 'isDisplayBoardUser',
      isTechnicalUser: 'isTechnicalUser',
      isPanelTechnicianUser: 'isPanelTechnicianUser',
      isPaintTechnicianUser: 'isPaintTechnicianUser',
      isCustomerUser: 'isCustomerUser',
      isStripperFitterUser: 'isStripperFitterUser',
      getterToken: 'card/getToken',
      getterTokens: 'card/getTokens',
      ceStatuses: 'ceStatuses',
      // Unique filter values from card module Vuex
      getterUniqueInsurers: 'card/getUniqueInsurers',
      getterUniqueCardNumbers: 'card/getUniqueCardNumbers',
      getterUniqueEstimateNumbers: 'card/getUniqueEstimateNumbers',
      getterUniquePartNumbers: 'card/getUniquePartNumbers',
      getterUniqueRegos: 'card/getUniqueRegos',
      getterUniqueMakes: 'card/getUniqueMakes',
      getterUniqueModels: 'card/getUniqueModels',
      getterUniqueVehicleOwners: 'card/getUniqueVehicleOwners',
    }),
    isCanSearchBySomeFields() {
      return !this.isPDRTechnicianUser && !this.isPanelTechnicianUser && !this.isPaintTechnicianUser && !this.isStripperFitterUser && !this.isDisplayBoardUser
    },
    filter: {
      get() {
        return this.$store.getters.cardFilter;
      },
      set(value) {
        this.$store.commit('setCardFilter', value);
      }
    },
    // computedSearchFilters_Old() {
    //   let cardNumbers = {};
    //   let estimateNumbers = {};
    //   let partNumbers = {};
    //   let insurers = {};
    //   let regos = {};
    //   let makes = {};
    //   let models = {};
    //   let vehicleOwner = {};
    //
    //   this.cardsAll.forEach(card => {
    //     if (card.card_number) {
    //       cardNumbers[card.card_number.trim().toLowerCase()] = {label: card.card_number.trim()}
    //     }
    //   })
    //
    //   this.cardsAll.forEach(card => {
    //     if (card.customer_name) {
    //       vehicleOwner[card.customer_name.trim().toLowerCase()] = {label: card.customer_name.trim()}
    //     }
    //   })
    //
    //   this.cardsAll.forEach(card => {
    //     if (card.estimateNumber) {
    //       estimateNumbers[card.estimateNumber.trim().toLowerCase()] = {label: card.estimateNumber.trim()}
    //     }
    //   })
    //
    //   this.cardsAll.forEach(card => {
    //     if (card.rego_number) {
    //       regos[card.rego_number.trim().toLowerCase()] = {label: card.rego_number.trim()}
    //     }
    //   })
    //
    //   this.cardsAll.forEach(card => {
    //     if (card.make) {
    //       makes[card.make.trim().toLowerCase()] = {label: card.make.trim()}
    //     }
    //   })
    //
    //   this.cardsAll.forEach(card => {
    //     if (card.model) {
    //       models[card.model.trim().toLowerCase()] = {label: card.model.trim()}
    //     }
    //   })
    //
    //   this.cardsAll.forEach(card => {
    //     if (card.insurance) {
    //       insurers[card.insurance.trim().toLowerCase()] = {label: card.insurance.trim()}
    //     }
    //   })
    //
    //   this.cardsAll.forEach(card => {
    //     if (card.partNumbers) {
    //       let numbers = card.partNumbers.split(' ')
    //       _.forEach(numbers, n => {
    //         if (_.trim(n)) {
    //           partNumbers[n.toLowerCase().trim()] = {label: n.toLowerCase().trim()}
    //         }
    //       })
    //     }
    //   })
    //
    //   partNumbers = _.orderBy(Object.values(partNumbers), [(itm) => itm.label.toLowerCase().trim()], ['asc'])
    //   cardNumbers = _.orderBy(Object.values(cardNumbers), [(itm) => itm.label.toLowerCase().trim()], ['asc'])
    //   vehicleOwner = _.orderBy(Object.values(vehicleOwner), [(itm) => itm.label.toLowerCase().trim()], ['asc'])
    //   estimateNumbers = _.orderBy(Object.values(estimateNumbers), [(itm) => itm.label.toLowerCase().trim()], ['asc'])
    //   regos = _.orderBy(Object.values(regos), [(itm) => itm.label.toLowerCase().trim()], ['asc'])
    //   makes = _.orderBy(Object.values(makes), [(itm) => itm.label.toLowerCase().trim()], ['asc'])
    //   models = _.orderBy(Object.values(models), [(itm) => itm.label.toLowerCase().trim()], ['asc'])
    //   insurers = _.orderBy(Object.values(insurers), [(itm) => itm.label.toLowerCase().trim()], ['asc'])
    //
    //   let result = [
    //     {
    //       id: 'cardNumber',
    //       label: 'File Number',
    //       iconClass: 'bx-user',
    //       options: [
    //         cardNumbers,
    //       ]
    //     },
    //     {
    //       id: 'estimateNumber',
    //       label: 'Estimate Number',
    //       iconClass: 'bx-user',
    //       options: [
    //         estimateNumbers,
    //       ]
    //     },
    //     {
    //       id: 'partNumber',
    //       label: 'Part Number',
    //       iconClass: 'bx-user',
    //       options: [
    //         partNumbers,
    //       ]
    //     },
    //     {
    //       id: 'insurer',
    //       label: 'Insurer',
    //       iconClass: 'bx-user',
    //       options: [
    //         insurers,
    //       ]
    //     },
    //     {
    //       id: 'rego',
    //       label: 'Rego',
    //       iconClass: 'bx-user',
    //       options: [
    //         regos,
    //       ]
    //     },
    //     {
    //       id: 'make',
    //       label: 'Make',
    //       iconClass: 'bx-user',
    //       options: [
    //         makes,
    //       ]
    //     },
    //     {
    //       id: 'model',
    //       label: 'Model',
    //       iconClass: 'bx-store',
    //       options: [
    //         models
    //       ]
    //     },
    //     {
    //       id: 'customerName',
    //       label: 'Vehicle Owner',
    //       iconClass: 'bx-store',
    //       options: [
    //         vehicleOwner
    //       ]
    //     },
    //   ]
    //   if (!this.isCanSearchBySomeFields) {
    //     result = _.filter(result, (r) => {
    //       return r.id !== 'estimateNumber' && r.id !== 'insurer'
    //     })
    //   }
    //   return result
    // },
    // Unique values from card module Vuex getters (collected in loadCards/cardsUpdated mutations).
    computedSearchFilters() {
      let result = [
        {
          id: 'cardNumber',
          label: 'File Number',
          iconClass: 'bx-user',
          options: [ this.getterUniqueCardNumbers ]
        },
        {
          id: 'estimateNumber',
          label: 'Estimate Number',
          iconClass: 'bx-user',
          options: [ this.getterUniqueEstimateNumbers ]
        },
        //#961
        // {
        //   id: 'partNumber',
        //   label: 'Part Number',
        //   iconClass: 'bx-user',
        //   options: [
        //     this.getterUniquePartNumbers,
        //   ]
        // },
        {
          id: 'insurer',
          label: 'Insurer',
          iconClass: 'bx-user',
          options: [ this.getterUniqueInsurers ]
        },
        {
          id: 'rego',
          label: 'Rego',
          iconClass: 'bx-user',
          options: [ this.getterUniqueRegos ]
        },
        {
          id: 'make',
          label: 'Make',
          iconClass: 'bx-user',
          options: [ this.getterUniqueMakes ]
        },
        {
          id: 'model',
          label: 'Model',
          iconClass: 'bx-store',
          options: [ this.getterUniqueModels ]
        },
        {
          id: 'customerName',
          label: 'Vehicle Owner',
          iconClass: 'bx-store',
          options: [ this.getterUniqueVehicleOwners ]
        },
      ]

      if (!this.isCanSearchBySomeFields) {
        result = _.filter(result, (r) => {
          return r.id !== 'estimateNumber' && r.id !== 'insurer'
        })
      }
      return result
    },
    isDisabledModalFinishButton () {
      return !!(_.isEmpty(this.reasonForDeclineORM) || _.isEmpty(this.locationForDecline));
    },
    computedCardsForCopyCard() {
      let vm = this;
      let cards = _.filter(this.cardsAll, function (i) {
        return !(i.state === "3" || i.status_name == "Invoiced" || i.status_name == "Closed");
      });
      return cards;
    },

    isHasNotFilters() {
      return !this.isCardNumberFilterActive && !this.isPartNumberFilterActive && !this.isInsurerNameFilterActive
          && !this.isRegoFilterActive && !this.isMakeFilterActive && !this.isModelFilterActive && !this.isEstimateNumberFilterActive && !this.isCustomerNameFilterActive
    },

    isCardNumberFilterActive() {
      return this.getIsActiveFilter('cardNumber')
    },
    computedCardNumberFilter() {
      return this.getActiveFilter('cardNumber')
    },
    isPartNumberFilterActive() {
      return this.getIsActiveFilter('partNumber')
    },
    computedPartNumberFilter() {
      return this.getActiveFilter('partNumber')
    },

    isEstimateNumberFilterActive() {
      return this.getIsActiveFilter('estimateNumber')
    },
    computedEstimateNumberFilter() {
      return this.getActiveFilter('estimateNumber')
    },

    isCustomerNameFilterActive() {
      return this.getIsActiveFilter('customerName')
    },
    computedCustomerNameFilter() {
      return this.getActiveFilter('customerName')
    },

    isInsurerNameFilterActive() {
      return this.getIsActiveFilter('insurer')
    },
    computedInsurerNameFilter() {
      return this.getActiveFilter('insurer')
    },

    isRegoFilterActive() {
      return this.getIsActiveFilter('rego')
    },
    computedRegoFilter() {
      return this.getActiveFilter('rego')
    },

    isMakeFilterActive() {
      return this.getIsActiveFilter('make')
    },
    computedMakeFilter() {
      return this.getActiveFilter('make')
    },

    isModelFilterActive() {
      return this.getIsActiveFilter('model')
    },
    computedModelFilter() {
      return this.getActiveFilter('model')
    },
  }
}
</script>

<style scoped>

</style>
